/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_ReviewsInputs */

const he_home_trust_reviews = /** @type {(inputs: Home_Trust_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קראו וכתבו ביקורות`)
};

const en_home_trust_reviews = /** @type {(inputs: Home_Trust_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read & write reviews`)
};

/**
* | output |
* | --- |
* | "Read & write reviews" |
*
* @param {Home_Trust_ReviewsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_trust_reviews = /** @type {((inputs?: Home_Trust_ReviewsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_ReviewsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_trust_reviews(inputs)
	return en_home_trust_reviews(inputs)
});